import { flow, observable, action } from 'mobx';
import { apiResponse, apiState, ApiError } from '../../Api';
import { RootStore } from '../createStore';
import { AlunoModel } from './Model';
import { ativarDesativarUmAluno, fecthAluno, fetchTodosAlunos, fecthAlunoParaAutenticacaoPreProjeto } from './Service';

export class AlunoStore {
    @observable public aluno: AlunoModel = new AlunoModel();
    @observable public alunos: Array<AlunoModel> = [];

    @observable alunoListState: apiState = apiState.loading;
    @observable alunoState: apiState = apiState.loading;

    @observable alunoListQuery = {
        search: '',
        page: 1,
        pageSize: 10
    };

    rootStore: RootStore;

    constructor(rootStore: RootStore) {
        this.rootStore = rootStore;
    }

    @action
    update = (object: string, field: string, value: any) => {
        this[object][field] = value;
    };

    getAlunos = flow(function* (this: AlunoStore, concat: boolean = false) {
        this.alunoListState = apiState.loading;

        const { page, pageSize, search } = this.alunoListQuery;

        const fetchAlunos: apiResponse<AlunoModel[]> = yield fetchTodosAlunos(
            page, pageSize, search
        );

        this.alunoListState = fetchAlunos.status;

        this.alunos = concat
            ? this.alunos.concat(fetchAlunos.data)
            : fetchAlunos.data;
    });

    getAluno = flow(function* (this: AlunoStore, alunoId: number) {
        this.alunoState = apiState.loading;

        const aluno = yield fecthAluno(alunoId);

        this.alunoState = aluno.status;
        this.aluno = aluno.data;
    });

    fecthAlunoParaAutenticacaoPreProjeto = flow(function* (this: AlunoStore) {
        this.alunoState = apiState.loading;

        const aluno = yield fecthAlunoParaAutenticacaoPreProjeto();
        this.alunoState = aluno.status;
        this.aluno = aluno.data;
    });

    ativarDesativarUmAluno = flow(function* (this: AlunoStore) {
        const aluno = this.aluno

        if (aluno.alunoAtivo) {
            const response: apiResponse<ApiError[]> = yield ativarDesativarUmAluno(aluno.id, false);

            if (response.status === apiState.done) {
                this.aluno.alunoAtivo = false;
            }
        } else {
            const response: apiResponse<ApiError[]> = yield ativarDesativarUmAluno(aluno.id, true);

            if (response.status === apiState.done) {
                this.aluno.alunoAtivo = true;
            }
        }
    });
}

